import React, { useState } from "react";

import "./styles.css";
import {
  FaGithubSquare,
  FaGlobe,
  FaInstagram,
  FaLinkedinIn,
  FaQuoteRight
} from "react-icons/fa";
const About = () => {
  // const { name, job, image, info } = review[0];

  return (
    <>
      <article className="review">
        <div className="img-container">
          {/* <img src={image} alt={name} className="person-img" /> */}
          <span className="quote-icon">
            <FaQuoteRight /> 🇪🇹
          </span>
        </div>
        <h4
          className="author"
          style={{
            margin: 15,
            color: "black",
            fontSize: 29
          }}
        >
          👨‍💻 A2SV - Community
        </h4>
        <div className="underline"></div>
        <p
          className="job"
          style={{
            fontWeight: "bold",
            color: "black",
            marginBottom: 7.5,
            marginTop: 13,
            fontSize: 16,
            textAlign: "center"
          }}
        >
          ✅ About A2SV The Problem A2SV Are Solving
        </p>
        <p className="info" style={{ color: "white" }}>
          Africa’s future depends on innovation. Transformative technologies can
          drive rapid economic growth and lift millions of people out of
          poverty. However, university computer science education is misaligned
          with global market needs and fails to incorporate practice-based
          learning, leaving students unable to apply their skills in real-world
          contexts. With few global tech companies on the continent, aspiring
          engineers don’t have access to experienced mentors, or the opportunity
          to work on products that operate at scale. Smart and ambitious
          students who could create life-changing technologies aren’t able to
          reach their potential.
        </p>
        <p
          className="job"
          style={{
            fontWeight: "bold",
            color: "black",
            marginBottom: 7.5,
            marginTop: 13,
            fontSize: 16,
            textAlign: "center"
          }}
        >
          ✅ How A2SV Are Solving It
        </p>

        <p className="info" style={{ color: "white" }}>
          A2SV upskill high-potential university students, connect them with
          internship interviews at the world’s top tech companies, and create
          digital solutions to urgent problems in their home countries together.
          The program is free for students, making the opportunity available for
          youth who have talent but lack the means to use it. A2SV’s rigorous
          three-month training program prepares students for internships with
          companies like Google, Palantir, and LinkedIn. The internships give
          students the experience they need to design and build products that
          improve the quality of life in Africa. We are unlike any other
          programming academy because we permanently incorporate students’
          ventures under the umbrella of the organization, going beyond training
          to deliver concrete impact. Offering students an ecosystem to
          actualize their ideas means that up-and-coming developers use their
          skills to benefit Africa, rather than taking their talent elsewhere.
        </p>

        <div className="btn-container">
          <a
            style={{ textDecoration: "none", background: "transparent" }}
            href="https://www.instagram.com/a2sv_org/"
            target="_blank"
          >
            <button className="prev-btn">
              <FaInstagram />{" "}
            </button>
          </a>
          <a
            style={{ textDecoration: "none", background: "transparent" }}
            href="https://www.linkedin.com/company/a2sv/"
            target="_blank"
          >
            <button className="prev-btn">
              <FaLinkedinIn />{" "}
            </button>
          </a>
          <a
            style={{ textDecoration: "none", background: "transparent" }}
            href="https://a2sv.org"
            target="_blank"
          >
            <button className="prev-btn">
              <FaGlobe />{" "}
            </button>
          </a>
        </div>
      </article>
    </>
  );
};
export default About;
